import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StationBadgeComponent } from './station-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
    declarations: [StationBadgeComponent],
    imports: [CommonModule, MatIconModule, RouterModule, CustomerPrivacyModule, MatTooltipModule],
    exports: [StationBadgeComponent],
})
export class StationBadgeModule {}
